import React from "react";

const MergeProgressIndicator = ({ isVisible, currentStep, progress, error }) => {
  if (!isVisible) return null;

  return (
    <div className="text-center py-5">
      <div className="mb-4">
        <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
      
      <h5 className="mb-3">{currentStep || "Processing Merge..."}</h5>
      
      {progress !== undefined && (
        <div className="mb-3">
          <div className="progress" style={{ height: "25px" }}>
            <div
              className="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              style={{ width: `${progress}%` }}
              aria-valuenow={progress}
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {progress}%
            </div>
          </div>
        </div>
      )}

      {error && (
        <div className="alert alert-danger mt-3">
          <strong>Error:</strong> {error}
        </div>
      )}

      <p className="text-muted mt-3">
        Please do not close this window while the merge is in progress...
      </p>
    </div>
  );
};

export default MergeProgressIndicator;

